/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { TopListable } from '@zcode/bizos'
import type { Listable, Pin, Property, RawPinInventorySearch } from '@zcode/state-type'
import invariant from 'tiny-invariant'

export const getDetailHref = (
  entity: Listable | Property | Pin<RawPinInventorySearch> | TopListable
) => {
  invariant(!!entity, 'getDetailHref called without entity')
  const { url } = entity
  if (entity instanceof TopListable || !entity.isBuilding) {
    if ('isNoDetailPage' in entity && entity.isNoDetailPage) {
      return entity.externalUrl
    }
    if ('paUrl' in entity && 'paShouldIndex' in entity && entity?.paShouldIndex) {
      // return `/address/${entity.paUrl}#${entity.uId}`  // use this line to open the details modal automatically
      return `/address/${entity.paUrl}`
    }
  }
  return url
}
